<template>
<div>

    <v-dialog v-model="dialog" persistent scrollable fullscreen>
        <v-card>
            <v-card-title class="text-h5 pl-6 font-weight-regular"><span>{{form.id?'Edit':'Add'}} Highlight</span>
                <v-spacer/><v-switch v-model="form.isActive" label="Is Active" color="green" class="mt-n2" hide-details inset/>
            </v-card-title>
            <v-divider/>
            <v-card-text class="pb-0" id="h-form-card">
                <v-form ref="form">
                    <v-row>

                        <v-col cols="6">
                            <label class="text-uppercase grey--text font-weight-bold">Highlight Title*</label>
                            <v-text-field outlined v-model="form.caption" class="mt-3" maxlength="30"
                                          :rules="[v => v&&!!v.trim() || 'Highlight Title Required.']"/>
                        </v-col>
                      <v-col cols="6">
                        <label class="text-uppercase grey--text font-weight-bold">Whatsapp Number</label>
                        <v-text-field outlined v-model="form.mobile" class="mt-3" type="number"
                                      :rules="[v => !v || v.length === 10 || 'Whatsapp Number Must be 10 Digits']"/>
                      </v-col>
                      <v-col cols="12">
                        <label class="text-uppercase grey--text font-weight-bold">Whatsapp Default Message</label>
                        <v-textarea outlined v-model="form.whatsappMessage" class="mt-3" rows="5"/>
                      </v-col>
                        <v-col cols="12">
                            <label class="text-uppercase grey--text font-weight-bold">Schedule</label>
                            <v-radio-group class="mt-3 " row outlined dense v-model="form.isSchedule" @change="onChangeSchedule">
                                <v-radio label="Now" :value="false"></v-radio>
                                <v-radio label="Schedule" :value="true"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="6">
                            <label class="text-uppercase grey--text font-weight-bold">Start Time*</label>
                            <v-datetime-picker v-model="form.startTime" dateFormat="dd-MM-yyyy" timeFormat="hh:mm a" :disabled="!form.isSchedule"
                                               :textFieldProps="{outlined:'outlined', rules: [v => !!v || 'Start Time required']}"
                                               :datePickerProps="{min: moment().format('YYYY-MM-DD')}" @input="onStartTime">
                                <template v-slot:dateIcon><v-icon>mdi-calendar</v-icon></template>
                                <template v-slot:timeIcon><v-icon>mdi-clock</v-icon></template>
                            </v-datetime-picker>
                        </v-col>
                        <v-col cols="6">
                            <label class="text-uppercase grey--text font-weight-bold">End Time*</label>
                            <v-datetime-picker v-model="form.endTime" dateFormat="dd-MM-yyyy" timeFormat="hh:mm a"
                                               :textFieldProps="{outlined:'outlined', rules: [v => !!v || 'End Time required',
                                                 v => moment(form.endTime).unix()>moment(form.startTime).unix() || 'End Time should be greater than Start Time']}"
                                               :datePickerProps="{min: form.startTime?moment(form.startTime).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')}">
                                <template v-slot:dateIcon><v-icon>mdi-calendar</v-icon></template>
                                <template v-slot:timeIcon><v-icon>mdi-clock</v-icon></template>
                            </v-datetime-picker>
                        </v-col>
                        <v-col cols="12"><v-divider/></v-col>
                        <v-col cols="12" class="text-h6">Add Images/Videos</v-col>
                        <v-col cols="6" class="">
                            <label class="text-uppercase grey--text font-weight-bold">Attach Image/Video*</label>
                            <input id="file" @change="onSelectFile" type="file" accept="image/*, .jfif, video/*" v-if="dialog" style="display: none"/>
                            <div class="image-div mt-3" @click="openFile">
                                <ImageBox :imageLoading="imageLoading" icon="upload"
                                          :imageUrl="imgForm.type==='IMAGE'?imgForm.path:imgForm.thumbnail"/>
                               <!-- <video v-else width="378" height="190" :src="Constants.base_url+imgForm.path" style="object-fit: cover"/> -->
                            </div>
                        </v-col>
                        <v-col cols="4" class="my-auto">
                            <label class="text-uppercase grey--text font-weight-bold">Caption</label>
                            <v-text-field outlined v-model="imgForm.caption" class="mt-3" maxlength="100"/>
                        </v-col>
                        <v-col cols="auto" class="my-auto ml-12">
                            <v-btn class="primary" :disabled="!imgForm.path" @click="addImage">Add</v-btn>
                        </v-col>
                        <v-col cols="12">
                            <v-data-table :headers="imageHeaders" :items="images" :hide-default-footer="images.length<10">
                              <template v-slot:body="{ items }">
                                <tr v-for="(item,index) in items" :key="index" class="py-0">
                                  <td class="px-4 my-0">
                                      <v-avatar tile class="my-3 avatar mr-6">
                                        <v-img :src="imgWpx(item.type==='IMAGE'?item.path:item.thumbnail,200)"/>
                                    </v-avatar>
                                  </td>
                                  <td class="px-4 my-0">{{item.type || '-'}}</td>
                                    <td class="px-4 my-0">{{item.caption || '-'}}</td>
                                  <td class="px-4 my-0">
                                    <v-btn icon @click="onRemoveImage(index, item)" color="red"><v-icon>mdi-delete</v-icon></v-btn>
                                  </td>
                                </tr>
                              </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="mt-5">
                <v-spacer></v-spacer>
                <v-btn class="text-capitalize white elevation-0" text @click="closeDialog">Close</v-btn>
                <v-btn class="primary px-3 text-capitalize" :loading="formLoading" dark @click="handleSubmit">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <canvas id="h-form-canvas" v-if="dialog"></canvas>
    <ConfirmationDialog :confirmationMessage="confirm.message" @confirm="confirm.method" @close="confirm.closeMethod"
                        v-if="confirm.enable"/>
    <Snackbar :toaster="toaster"></Snackbar>
</div>
</template>

<script>
import Constants from "../../Constants/Constants";
import NetworkCommunicator from "../../plugins/NetworkResourceHandler";
import Snackbar from "../../components/Common/Snackbar";
import ImageBox from "../../components/Common/ImageBox";
import {CREATE_UPDATE_BANNER} from "../../graphql/mutations/Banners";
import moment from "moment";
import ConfirmationDialog from "../../components/Common/ConfirmationDialog";
let defaultMessage = 'Hi, \n' + '\n' + 'I am cheaperzone customer.\n' +
    '\n' + 'I am interested in your services posted in cheaperzone.\n' +
    '\n' + 'I would like to contact you for more details.\n' + '\n' + 'Thank you!'
let user = JSON.parse(localStorage.user);
let toaster = { enable: false, color: 'green', message: '' };
let form = {caption:'', isActive:true, isSchedule:false, mobile:null, whatsappMessage: defaultMessage,
    createdBy:user.id, updatedBy:user.id, startTime:new Date(), endTime:moment().add(1, 'day').toDate(),
    bannerType:Constants.BannerType.Highlight};
let imgForm = {path:'', caption:'', type:'IMAGE', duration:null, thumbnail:null, createdBy:user.id, updatedBy:user.id};
export default {
    name: "HighlightForm",
    components: {ConfirmationDialog, ImageBox, Snackbar},
    props: ['dialog', 'bannersLength'],
    data(){
        return{
            Constants, moment,
            form: {...form},
            imgForm: {...imgForm},
            formLoading: false,
            imageLoading: false,
            toaster: toaster,
            images: [],
            imageHeaders: [{text:'Image/Video', value:'image'}, {text:'Type', value:'type'},
                {text:'Caption', value:'caption'}, {text:'Action', value:'action'}],
            deleteAttachmentIds: [],
            confirm: {enable: false},
            // showFile: true
        }
    },
    watch:{
        'dialog': function(val){
            if(val && !this.form.id){
                this.form.startTime = new Date();
                this.form.endTime = moment().add(1, 'day').toDate();
            }
        }
    },
    methods:{
        onStartTime(){
            this.form.endTime = moment(this.form.startTime).add(1, 'day').toDate();
        },
        addImage(){
            this.images.push(this.imgForm);
            this.imgForm = {...imgForm};
        },
        onRemoveImage(index, image){
            this.confirm = {enable:true, message:'Are you sure want to remove Image?',
                method:() => this.removeImage(index, image), closeMethod:() => this.confirm = {enable: false}};
        },
        removeImage(index, image){
            this.images.splice(index, 1);
            if(image.id) this.deleteAttachmentIds.push(image.id);
            this.confirm = {enable: false};
        },
        openFile(){
            document.getElementById('file').click();
        },
        async checkVideo(file){
            let video = document.createElement('video');
            video.preload = 'metadata';

            video.src = URL.createObjectURL(file);
            video.load();
            await new Promise (resolve => video.onloadedmetadata = () => {
                window.URL.revokeObjectURL(video.src);
                resolve();
            });
            // video.currentTime = 1.5;
            setTimeout(() => { video.currentTime = 1.5 }, 200);
            await new Promise (resolve => video.onseeked = () => {
                resolve();
            });
            return video;
        },
        async uploadVideoThumbnail(video){
            let canvas = document.getElementById('h-form-canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
            let file = Constants.dataURLtoFile(canvas.toDataURL(), 'videoThumbnail.png');
            let formData = new FormData();
            formData.append('image', file);
            formData.append('name', file.name);
            let response = await NetworkCommunicator('POST', Constants.api_url + 'v1/upload', formData);
            if(response.flag) return response.data;
        },
        async onSelectFile(evt){
            this.imageLoading = true;
            let file = evt.target.files[0];
            if(!file) return this.imageLoading = false;
            let type = file.type.split('/')[0].toUpperCase();
            if(type === 'VIDEO'){
             let video = await this.checkVideo(file);
             if(video.duration > 120) {
                 this.toaster = {...toaster, enable:true, color:'red', message: 'Please upload video with play time less than 2 minutes'};
                 return this.imageLoading = false;
             }
             this.imgForm.duration = video.duration;
             this.imgForm.thumbnail = await this.uploadVideoThumbnail(video);
            }
            let formData = new FormData();
            formData.append('image', file);
            formData.append('name', file.name);
            NetworkCommunicator('POST', Constants.api_url + 'v1/upload', formData).then(res => {
                if(res.flag){
                    this.imgForm.path = res.data;
                    this.imgForm.type = type;
                }else{
                    this.toaster = {...toaster, enable:true, message: 'Image Upload Failed'}
                }
                evt.target.value = '';
                this.imageLoading = false
            }).catch(function(err){
                console.log('Upload File Error', err)
                this.toaster = {...toaster, enable:true, message: 'Image Upload Failed'}
                this.imageLoading = false
            })
        },
        onChangeSchedule(val){
            if(!val) this.form.startTime = new Date();
            this.onStartTime();
        },
        onEditBanner(item){
            Object.copyExistingKeys(this.form, item);
            this.form.id = item.id;
            this.form.startTime = moment(item.startTime).toDate();
            this.form.endTime = moment(item.endTime).toDate();
            // eslint-disable-next-line no-unused-vars
            this.images = item.BannerImages.map(({__typename, ...rest}) => ({...rest}));
        },
        handleSubmit(){
            if(this.$refs.form.validate() && this.images.length)
                this.saveBanner();
            else if(this.$refs.form.validate() && !this.images.length)
                this.toaster = {color: 'red', enable:true, message: 'Please add at least one Image'}
        },
        async saveBanner(){
            this.formLoading = true;
            this.form.id = this.form.id || Constants.generateUUID();
            let response = await this.$apollo.mutate({
                mutation: CREATE_UPDATE_BANNER,
                variables: {
                    banner: {sequenceNo: this.bannersLength, ...this.form, imageUrl:this.images[0].path},
                    updateColumns: [...Object.keys(this.form), 'updatedBy'],
                    attachments: this.images.map(i => ({...i, bannerId: this.form.id})),
                    updateColumnsAttachment: ['path', 'caption', 'type', 'createdBy', 'updatedBy'],
                    deleteAttachmentIds: this.deleteAttachmentIds
                }
            })
            this.formLoading = false;
            this.toaster = {enable:true, color:'green', message: `Highlight saved Successfully`};
            if(response.data) this.closeDialog()
        },
        closeDialog(){
            this.$refs.form.resetValidation();
            this.imageLoading = false;
            this.form = {...form};
            this.imgForm = {...imgForm};
            this.images = [];
            this.deleteAttachmentIds = [];
            this.$emit('update:dialog', false);
            document.getElementById('h-form-card').scrollTop = 0;
        }
    }
}
</script>

<style scoped>
.image-div{
    width: 380px;
    height: 190px;
}
.mt-24{
    margin-top: 96px;
}
</style>
